import React, { Component } from 'react';

import AppBar from 'material-ui/AppBar';
import { Card, CardHeader} from 'material-ui/Card';

// import Payment from './Payment';
import ConfirmDetails from './ConfirmDetails';

import 'whatwg-fetch';
import Util from "../../Util";
import {index as styles} from './sms_payment.css';

class PaymentContainer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: '',
      phone: '',
      email: '',
      numberPlate: '',
      carType: null,
      washType: null,
      address: null,
      washPrice: 0,
      cost: null,
      paid: false,
      isSmallScreen: false,
      loadSuccessful: false,
    };

    this.updateField = this.updateField.bind(this);
    this.setHasError = this.setHasError.bind(this);

    this.updateDimensions = this.updateDimensions.bind(this);
    this.getBookingDetails = this.getBookingDetails.bind(this);
  }

  updateField(fieldName, fieldValue) {
    const detailsObj = {};
    detailsObj[fieldName] = fieldValue;
    this.setState(detailsObj);
  }

  setHasError(fieldName, hasError) {
    const detailsObj = {};
    detailsObj[fieldName + 'Error'] = hasError;
    this.setState(detailsObj);
  }

  updateDimensions() {
    const width = window.innerWidth;
    const small = width < 768;
    this.setState({
      isSmallScreen: small
    });

    styles.marginLeft = this.state.isSmallScreen ? '5%' : '10%';
    styles.marginRight = this.state.isSmallScreen ? '5%' : '10%';
  }

  getBookingDetails(linkId) {
    return Util.backendGet('sms-bot/get-payment/' + linkId, null).then((json) => {
      const result = json.details;
      if (!result['paid']) {
        this.setState({
          linkId: linkId,
          name: result['name'],
          phone: result['phone'],
          email: result['email'],
          numberPlate: result['number_plate'],
          carType: "PLACEHOLDER SEDAN",
          washType: result['wash_type'],
          address: result['address'],
          cost: result['customer_charged'],
          washDateStart: result['available_datetime'],
          washDateEnd: result['finish_by_datetime'],
          loadSuccessful: true,
        });
      } else {
        this.setState({paid: true, loadSuccessful: true});
      }
    }).catch((err) => {
      console.log('ERROR:', err);
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.updateDimensions();

    const linkId = this.props.match.params['link_id'];
    this.getBookingDetails(linkId);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render() {
    return (
      <div>
        <AppBar
          title={<img src="../default/icon.png" alt="logo" style={styles.imageLogo} />}
          style={styles.navbar}
          titleStyle={styles.navbarInner}
          showMenuIconButton={false}
        />

        <div style={styles.gap} />

        <div style={styles.container}>
          {this.state.loadSuccessful && (this.state.paid ? <Card><CardHeader title="You have already paid for your SMS booking!" /></Card> : <ConfirmDetails details={this.state}/>)}
          {!this.state.loadSuccessful && <Card><CardHeader title="No booking details found!" /></Card>}
        </div>

        <div id="footer">
          <div id="footerText">
            Powered by <a target="_blank" href="https://www.wipehero.com.au/">WipeHero</a> &copy; 2017
          </div>
        </div>
      </div>
    );
  }
}

export default PaymentContainer;



// WEBPACK FOOTER //
// ./src/app/components/sms_payment/index.js